import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import UserReservation from "../Reservation/UserReserves";
import { logout } from "../../Services/AuthService";
import Profile from "../Auth/Profile";
import ConfirmModal from "../../Components/Modals/ConfirmModal";
import UserComments from "../Comment/UserComments";
import { ViewAction } from "../../Enums/ViewActionEnum";

const UserProfile = () => {
  const [activeItem, setActiveItem] = useState("edit");
  const [openDialog, setOpenDialog] = useState(false);

  const navigate = useNavigate();

  const handleLogout = () => {
    setOpenDialog(true);
  };

  const handleConfirmLogout = () => {
    logout();
    setOpenDialog(false);
    navigate("/");
  };

  const menuItems = [
    {
      id: "edit",
      label: "ویرایش مشخصات",
      iconPath:
        "M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z",
    },
    {
      id: "reservations",
      label: "رزرو های من",
      iconPath:
        "M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z",
    },
    {
      id: "comment",
      label: "نظرات من",
      iconPath:
        "M21 6h-2v9H5v2c0 .55.45 1 1 1h12l4 4V7c0-.55-.45-1-1-1zm-4-4H3c-.55 0-1 .45-1 1v14l4-4h11c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1z",
    },
    {
      id: "logout",
      label: "خروج از حساب کاربری",
      iconPath:
        "M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.59L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z",
    },
  ];

  const renderContent = () => {
    switch (activeItem) {
      case "reservations":
        return <UserReservation />;
      case "edit":
        return <Profile action={ViewAction.EDIT} />;
      case "comment":
        return <UserComments />;
      default:
        return null;
    }
  };

  return (
    <div className="min-vh-75 iran-sans" dir="rtl">
      <div className="text-center text-lg-end mb-lg-5 me-lg-5 pe-lg-4 pt-4 me-sm-0 me-2">
        <h1 className="text-custom-primary highlight-box iran-sans fw-bold">
          حساب کاربری من
        </h1>
      </div>

      <div className="container">
        <div className="row justify-content-center justify-content-lg-between m-4 mt-5">
          {/* Menu */}
          <div className="col-12 col-md-10 col-lg-3 bg-light pb-4 rounded-4 pt-4 mb-4 mb-lg-0">
            <div className="d-grid gap-4">
              {menuItems.map((item) => (
                <div
                  key={item.id}
                  onClick={() => {
                    if (item.id === "logout") {
                      handleLogout();
                    } else {
                      setActiveItem(item.id);
                    }
                  }}
                  className={`menu-item d-flex align-items-center justify-content-between p-3 rounded-4 ${
                    activeItem === item.id
                      ? "primary-menu-item"
                      : "bg-white shadow-sm"
                  }`}
                  role="button"
                >
                  <span
                    className={`fs-6 fw-bold ${
                      activeItem === item.id
                        ? "text-white"
                        : "text-custom-primary"
                    }`}
                  >
                    {item.label}
                  </span>
                  <svg
                    className={`icon-size ${
                      activeItem === item.id
                        ? "text-white"
                        : "text-custom-secondary"
                    }`}
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d={item.iconPath} />
                  </svg>
                </div>
              ))}
            </div>
          </div>

          {/* Selected section data */}
          <div className="col-12 col-lg-8 bg-white rounded-4 p-4 pt-0">
            {renderContent()}
          </div>
        </div>
      </div>

      {/* Logout Confirmation Modal */}
      <ConfirmModal
        openDialog={openDialog}
        handleCloseDialog={() => setOpenDialog(false)}
        handleConfirm={handleConfirmLogout}
        text={["آیا از خروج از حساب کاربری خود مطمئن هستید؟"]}
        confirmText={"بله"}
        cancleText={"خیر"}
        title={"خروج از حساب کاربری"}
      />
    </div>
  );
};

export default UserProfile;
